import { useSelector } from "react-redux";
import { ClientType } from "../../redux/slices/authSlice";
import { RootState } from "../../redux/store";

export const useGetClientObjectFromList = (
  clientCode: string,
): ClientType | null => {
  const clientList = useSelector((state: RootState) => state?.auth)?.user
    ?.client_list;
  return clientList?.find((c) => c?.client_code === clientCode) || null;
};
